import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SessionService } from "src/app/services/session.service";
import * as moment from 'moment';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {

  contactUsForm: FormGroup;
  newsletterForm: FormGroup;
  submitted = false;
  submitted_news = false;
  apiUrl: any;    

  // tslint:disable-next-line: max-line-length
  constructor(private formBuilder: FormBuilder,
              private httpClient: HttpClient,
              private router: Router,
              private sess: SessionService,
              private spinnerService: Ng4LoadingSpinnerService)
              { }

  ngOnInit(): void {  
 

    this.contactUsForm = this.formBuilder.group({
      name: ['', [Validators.required,
        Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"), Validators.maxLength(45)]],
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required,
        Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"), Validators.maxLength(500)]],
      phone: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(7),
          Validators.maxLength(13),
        ],
      ],
      address: ['', [Validators.required,
        Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"), Validators.maxLength(50)]],
    });

    $(".mobile-menu").css("display", "none"); 
    
  }


  onSubmit(formAllData: any) {
    this.submitted = true; 
    
    if (this.contactUsForm.invalid) {
      return;
    }

    const obj = {
      name: formAllData.name,
      email: formAllData.email,
      message: formAllData.message,
      phone: formAllData.phone,
      address: formAllData.address
    };

    console.log('contactUsFormData: ', obj);
    this.postContactUs(obj);
  }

  postContactUs(jsonData: any) {
    this.apiUrl = environment.AUTHAPIURL + 'contact';

		this.spinnerService.show();
    this.httpClient.post<any>(this.apiUrl, jsonData).subscribe(data => {
      console.log('contactResponseData: ', data);

      if (data.status === true) {

        // Rest form fithout errors
        this.contactUsForm.reset();
        Object.keys(this.contactUsForm.controls).forEach(key => {
          this.contactUsForm.get(key).setErrors(null);
        });
        this.spinnerService.hide();
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true
        });
        this.submitted = false;
        this.ngOnInit();
      } else {
			  this.spinnerService.hide();
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text:  data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true
        });
      }
    });
  } 
    
}
